'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner/spinner';
import { LoadingMaskRootContext } from './context/loading-mask-root.context';
import { loadingMaskSpinnerRecipe } from './styles/loading-mask-spinner.styles';
import type { LoadingMaskSpinnerPropsInterface } from './types/loading-mask-spinner.types';

export const LoadingMaskSpinner = forwardRef<HTMLDivElement, LoadingMaskSpinnerPropsInterface>(
  (props: LoadingMaskSpinnerPropsInterface, forwardedRef) => {
    const {
      css: cssProp,
      className,
      loading = true,
      size = 'lg',
      onImpact = false,
      ...rest
    } = props;

    const context = useContext(LoadingMaskRootContext);

    const styles = css(
      loadingMaskSpinnerRecipe.raw({ loading: context.loading ?? loading }),
      cssProp,
    );

    return (
      <div
        className={cx('c11n', 'c11n_loading-mask__spinner', styles, className)}
        data-c11n-component="LoadingMask.Spinner"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        <Spinner
          size={context.iconSize ?? size}
          title={null} // LoadingMask uses VisuallyHidden instead
          onImpact={context.onImpact ?? onImpact}
        />
      </div>
    );
  },
);

LoadingMaskSpinner.displayName = 'LoadingMask.Spinner';
